/**
 * The side menu's named click handlers, registered by the frame and callable from anywhere.
 *
 * The server does not always give a menu item a route. Two built-ins carry a `clickHandler`
 * name instead (`server/app/configApi.js`): `exportContent`, used by 35 tenants, and
 * `previewApp`, used by 7. Angular resolved those names against `navigationService` itself,
 * so any caller could run them; `AppFrame` owns them now because one opens a dialog it holds.
 *
 * A module-level registry rather than context, because `HomeRedirect` needs them and is
 * mounted by the router rather than by the frame, so there is no prop path between the two.
 * Both handlers are frame-scoped and there is exactly one frame, so a singleton is honest
 * about the relationship rather than pretending it could be otherwise.
 */
let handlers = {};

export const registerMenuActions = (next) => {
  handlers = next || {};
};

/** Runs the named handler. Returns false if the name is not one we know. */
export const runMenuAction = (name) => {
  const handler = handlers[name];
  if (!handler) return false;
  handler();
  return true;
};
